import axios from 'axios'

const DEFAULT_ATTRIBUTES = {
  draft: true,
  'referral-code': 'corona-portal-anfrage'
}

export const postInquiry = (attributes, userId, companyId, multiplierId, referralCode) => {
  const url = `${process.env.REACT_APP_API_URL}/v1/inquiries`

  return axios({
    url,
    withCredentials: true,
    data: {
      data: {
        attributes: {
          ...DEFAULT_ATTRIBUTES,
          ...attributes,
          ...(referralCode && { 'referral-code': referralCode })
        },
        relationships: {
          ...(userId && {
            user: {
              data: {
                id: userId,
                type: 'users'
              }
            }
          }),
          ...(companyId && {
            company: {
              data: {
                id: companyId,
                type: 'companies'
              }
            }
          }),
          ...(multiplierId && {
            'multiplier-organization': {
              data: {
                id: multiplierId,
                type: 'multiplier-organizations'
              }
            }
          })
        }
      }
    },
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const fetchSession = () => {
  return axios({
    url: `${process.env.REACT_APP_API_URL}/v1/session`,
    withCredentials: true
  })
}

export const fetchUserId = () => {
  return fetchSession()
    .then(response => {
      const userData = response?.data?.data
      const canUserBeAttached = ['customer', 'multiplier'].includes(userData?.attributes?.role)

      if (canUserBeAttached) return userData?.id
    })
    .catch(() => { console.log('caught')})
}
